import React from "react";
import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemText,
  Paper,
  Typography,
} from "@mui/material";
import LogoCard from "components/LogoCard";
import QualityIndicate from "components/QualityIndicate";

export default function AboutPage() {
  const programs = [
    "Мой родны кут – 4 передачи (на белорусском языке)",
    "Городские новости – еженедельно (48 выпусков)",
    "Телекурьер – еженедельно (68 выпусков)",
    "Смотрите с нами (56 выпусков)",
    "Друг (8 выпусков)",
    "Кто есть кто (4 выпуска)",
    "Ди-джей-дэнс (2 выпуска)",
    "Интерактивный понедельник – еженедельно (52 выпуска)",
    "Во саду и в огороде (11 выпусков)",
    "Воскресная школа (11 выпусков)",
    "Леопольд (5 выпусков)",
    "Светский салон (18 выпусков)",
    "Видеоэрудит (7 выпусков)",
    "Музыкальные дрожжи (4 выпуска)",
    "Спортивные новости (18 выпусков)",
    "Эскулап (7 выпусков)",
    "12 месяцев (112 выпусков)",
    "Криминальная хроника (18 выпусков)",
    "Граммофон (8 выпусков)",
    "С миру по нитке (5 выпусков)",
    "Зелёная аптека (11 выпусков)",
  ];

  return (
    <Box
      sx={{
        py: {
          xs: 2,
          sm: 3,
        },
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: "100%",
          p: {
            xs: 2,
            sm: 3,
            md: 4,
          },
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 2,
          bgcolor: "background.paper",
        }}
      >
        <Typography
          variant="h4"
          component="h1"
          sx={{
            fontWeight: 700,
            mb: 2,
            fontSize: {
              xs: "1.6rem",
              sm: "2rem",
            },
          }}
        >
          О компании
        </Typography>

        <Divider sx={{ mb: 3 }} />

        <Box
        sx={{
            display: "grid",
            gridTemplateColumns: {
            xs: "1fr",
            sm: "1fr 1fr",
            },
            gap: {
            xs: 3,
            sm: 4,
            },
            mb: 4,
        }}
        >
        <LogoCard
            title="Логотип с 1992 по 2010 год"
            src="/sources/logo_old.png"
            alt="Старый логотип ООО «ТриАнда»"
            downloadName="trianda-logo-old.png"
        />

        <LogoCard
            title="Логотип с 2011 года"
            src="/sources/logo.png"
            alt="Логотип ООО «ТриАнда»"
            downloadName="trianda-logo.png"
        />
        </Box>

        <Divider sx={{ mb: 3 }} />

        <Typography paragraph>
          Общество с ограниченной ответственностью «ТриАнда» зарегистрировано
          решением Чашникского райисполкома №183 от 14.08.1992 года. Согласно
          действовавшему на тот момент законодательству в 1999 году ООО
          «ТриАнда» решением Витебского облисполкома №118 от 12.03.1999 года
          прошло государственную перерегистрацию.
        </Typography>

        <Typography paragraph>
          Основным видом деятельности общества является{" "}
          <Box component="strong">
            строительство и эксплуатация сетей кабельного телевидения
          </Box>
          , а также предоставление услуг населению с их использованием.
        </Typography>

        <Typography paragraph>
          ООО «ТриАнда» является членом общественной организации
          «Телекоммуникационный отраслевой союз».
        </Typography>

        <Typography paragraph>
          ООО «ТриАнда», как средство массовой информации, формировало
          собственные программы и готовило авторские передачи:
        </Typography>

        <List
          dense
          sx={{
            mb: 2,
            pl: 2,
            "& .MuiListItem-root": {
              display: "list-item",
              listStyleType: "disc",
              py: 0.25,
            },
          }}
        >
          {programs.map((program) => (
            <ListItem key={program}>
              <ListItemText
                primary={program}
                primaryTypographyProps={{
                  sx: {
                    lineHeight: 1.6,
                  },
                }}
              />
            </ListItem>
          ))}
        </List>

        <Typography paragraph>
          Всего с ноября 1992 года по июнь 2000 года нами было подготовлено 428
          авторских передач. В связи со значительными затратами на производство
          передач с 2000 года их выпуск был приостановлен, а деятельность
          компании была сосредоточена на развитии кабельной сети и ретрансляции
          телеканалов спутникового вещания.
        </Typography>

        <Typography paragraph>
          Так как город Новолукомль находится в зоне неуверенного приёма,
          удовлетворительный приём эфирных телеканалов на комнатные антенны
          затруднён. Использование кабельного телевидения даёт жителям
          возможность просмотра более 80 каналов различной тематики.
        </Typography>

        <Typography paragraph>
          За более чем 30 лет работы наши специалисты приобрели огромный опыт,
          позволяющий успешно решать вопросы, связанные со строительством,
          эксплуатацией и организацией сетей электросвязи.
        </Typography>

        <Typography paragraph>
          В период с 2008 по 2014 гг. ООО «ТриАнда» произвело замену устаревшей
          кабельной сети на современную оптоволоконную. Использование последней
          связано с необходимостью ввода новых сервисов для населения —
          цифрового телевидения, общегородской локальной сети и услуги доступа
          в Интернет.
        </Typography>

        <Typography sx={{ mb: 0 }}>
          В настоящее время ООО «ТриАнда» является единственным официально зарегистрированным
          юридическим лицом, которое предоставляет услуги по трансляции телевизионных каналов
          и рекламы в границах города Новолукомля.
        </Typography>

        <Divider sx={{ my: 3 }} />

        <QualityIndicate />


      </Paper>
    </Box>
  );
}